<card name="Store projects table">
  <div card content>
    <smart-table [headers]="headers" [source]="source" [navigate]="['/']">
      <ng-template smartTableColumn="name" let-item>
        <td>
          <span class="font-weight-medium">{{ item.name }}</span> <br>
          <small class="text-muted">{{ item.devMode }}</small>
        </td>
      </ng-template>

      <ng-template smartTableColumn="createdAt" let-item>
        <td>
          {{ item.createdAt | moment }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="active" let-item>
        <td>
          <badge-exist existText="Active" [item]="item.active"></badge-exist>
        </td>
      </ng-template>

      <ng-template smartTableColumn="free" let-item>
        <td>
          <badge-exist existText="Free" existColor="success" [item]="item.free"></badge-exist>
        </td>
      </ng-template>

      <ng-template smartTableColumn="product" let-item>
        <td>
          {{ item.product }}
        </td>
      </ng-template>

      <ng-template smartTableColumn="actions" let-item let-collapse="collapse">
        <td class="text-right text-nowrap">
          <div class="d-flex mx-n1">
            <button class="btn btn-primary btn-square mx-1"
                    [class.btn-icon]="collapse.isCollapsed"
                    (click)="collapse.toggle()">
              <icon-pen></icon-pen>
            </button>
            <button class="btn btn-danger btn-square btn-icon mx-1">
              <icon-trash></icon-trash>
            </button>
          </div>
        </td>
      </ng-template>

      <ng-template smartTableCollapse let-item let-collapse="collapse">
        <form class="row">
          <div class="col-60">
            <div class="form-group">
              <label for="name">Name</label>
              <input type="text" id="name" class="form-control" placeholder="Name" [ngModel]="item.name" [ngModelOptions]="{standalone: true}">
            </div>
          </div>
          <div class="col-30">
            <div class="form-group">
              <label for="product">Product</label>
              <input type="text" id="product" class="form-control" placeholder="Name" [ngModel]="item.product" [ngModelOptions]="{standalone: true}">
            </div>
          </div>
          <div class="col-30">
            <div class="form-group">
              <label for="type">Type</label>
              <input type="text" id="type" class="form-control" placeholder="Name" [ngModel]="item.type" [ngModelOptions]="{standalone: true}">
            </div>
          </div>
          <div class="col form-inline">
            <div class="form-check mr-5">
              <check-input type="checkbox" name="free" [ngModel]="item.free" [ngModelOptions]="{standalone: true}">Free</check-input>
            </div>

            <div class="form-check mr-5">
              <check-input type="checkbox" name="active" [ngModel]="item.active" [ngModelOptions]="{standalone: true}">Active</check-input>
            </div>

            <div class="form-check mr-5">
              <check-input type="checkbox" name="download">Available for downloading</check-input>
            </div>
          </div>
          <div class="col-auto">
            <div class="m-n2">
              <button class="btn btn-success m-2">
                Save changes
              </button>
              <button class="btn btn-outline-info m-2"
                      (click)="collapse.toggle()">
                Cancel
              </button>
            </div>
          </div>
        </form>
      </ng-template>
    </smart-table>
  </div>
</card>
